import { useState, useEffect } from "react";
import axios from "axios";
import { Phone, MessageSquare } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const WhatsAppSettingsForm = ({ settings, onSuccess }) => {
  const [whatsappNumber, setWhatsappNumber] = useState(settings?.whatsapp_number || '');
  const [whatsappMessage, setWhatsappMessage] = useState(settings?.whatsapp_message || '');
  const [loading, setLoading] = useState(false);
  const token = localStorage.getItem("token");

  useEffect(() => {
    if (settings) {
      setWhatsappNumber(settings.whatsapp_number || '');
      setWhatsappMessage(settings.whatsapp_message || '');
    }
  }, [settings]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await axios.put(
        `${API}/settings/site`,
        { 
          whatsapp_number: whatsappNumber,
          whatsapp_message: whatsappMessage
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      toast.success("WhatsApp settings updated!");
      onSuccess(res.data.settings);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Failed to update settings");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div className="space-y-2">
        <Label className="text-xs uppercase tracking-widest flex items-center gap-2">
          <Phone className="w-4 h-4" /> WhatsApp Number
        </Label>
        <Input
          type="text"
          value={whatsappNumber}
          onChange={(e) => setWhatsappNumber(e.target.value)}
          placeholder="50937209459"
          className="h-12 font-mono"
          data-testid="whatsapp-number"
        />
        <p className="text-xs text-slate-500">Enter number without + or spaces (e.g., 50937209459)</p>
      </div>
      <div className="space-y-2">
        <Label className="text-xs uppercase tracking-widest flex items-center gap-2">
          <MessageSquare className="w-4 h-4" /> Default Message
        </Label>
        <Input
          type="text"
          value={whatsappMessage}
          onChange={(e) => setWhatsappMessage(e.target.value)}
          placeholder="Hello! I need help with my shipment."
          className="h-12"
          data-testid="whatsapp-message"
        />
      </div>
      <Button
        type="submit"
        disabled={loading}
        className="w-full h-10 bg-green-500 hover:bg-green-600 text-white font-bold uppercase tracking-widest"
        data-testid="save-whatsapp-btn"
      >
        {loading ? "Saving..." : "Save WhatsApp Settings"}
      </Button>
    </form>
  );
};

export default WhatsAppSettingsForm;
